let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7LvcJ")).then(() => parcelRequire('3VtMs'));